import { isString } from "./assertion";
/**
 * Capitalizes the first character of a string
 *
 * @param value the string to capitalize
 */

export function toSentenceCase(value) {
  if (!isString(value)) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}
//# sourceMappingURL=string.js.map